import { observable, action } from 'mobx'
import { hashHistory } from 'react-router'
import { REALNAME_AUTH_PATH } from '@constant'
import { dGet } from '@core/utils'

class Store {
  @observable isShow_authModal = false

  @action
  toggleAuthModal = () => {
    this.isShow_authModal = !this.isShow_authModal
  }

  @action
  showAuthModal = async merchantInfo => {
    const showModal = dGet(merchantInfo, 'frontpage_config.is_pop_up')
    const isShowed = sessionStorage.getItem('authModal') == 1
    if (showModal && !isShowed) {
      this.isShow_authModal = true
      sessionStorage.setItem('authModal', '1')
    }
  }

  linkToAuth = () => {
    this.toggleAuthModal()
    hashHistory.push(REALNAME_AUTH_PATH)
  }
}

export default new Store()
